import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Close from "../../../assets/images/close-icon.png";
import { debounce } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ProfilePic from "../../../assets/images/dummy_profile.png";
import Loader from "../../../components/Loader/Loader";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { usePermissions } from "../../../context/permissionContext";
import { validatePermission } from "../../../utils/permissionUtils";
import { CircularProgressbar } from "react-circular-progressbar";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import "react-circular-progressbar/dist/styles.css";
import "../../../components/common/css/datatable.scss";

const Userlist = () => {
  const [query, setQuery] = useState("");
  const [percentage, setPercentage] = useState([]);
  const [loading, setLoading] = useState(false);
 
  const [open, setOpen] = useState(false);
  const [firstname, setFirstname] = useState();
  const [lastname, setLasttname] = useState();
  const [getEmail, setEmail] = useState();
  const [verfiecationStatus, setVerificationStatus] = useState();
  const [roles, setRoles] = useState([]);
  const [id, setID] = useState();
  const userData = JSON.parse(localStorage.getItem("admin"));
  const loginUserID = userData?.data?.id || null;
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });
   const { permissions, permissionsMapping } = usePermissions();
  const handleClose = () => setOpen(false);
  const handleOpen = (row) => {
    setOpen(true);
    setID(row?.id);
    setFirstname(row?.firstname);
    setLasttname(row?.lastname);
    setEmail(row?.email);
  };

  const updateFirstName = (e) => {
    let getFirstname = e.target.value;
    setFirstname(getFirstname);
  };

  const updateLastName = (e) => {
    let getFirstname = e.target.value;
    setLasttname(getFirstname);
  };
  
  function LinearProgressWithLabel(props) {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <LinearProgress
            style={{ width: 200, height: 5 }}
            variant="determinate"
            color={props.value > 50 ? "primary" : "secondary"}
            {...props}
          />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

  const handleQuery = useCallback(
    debounce((e) => {
      setQuery(e.target.value);
      setPageState({ ...pageState, page: 1 });
    }, 1000)
  );

  const fetchuserData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    // Construct the payload with dynamic verification filters
    let payload = {
      page: pageState.page,
      limit: pageState.pageSize,
      searchTerm: query, // Keep search functionality
    };

    // Apply filtering based on verification status
    if (verfiecationStatus === "individual_verified") {
      payload.isVerified = true;
    } else if (verfiecationStatus === "individual_non_verified") {
      payload.isVerified = false;
    } else if (verfiecationStatus === "corporate_verified") {
      payload.comp_isVerified = true;
    } else if (verfiecationStatus === "corporate_non_verified") {
      payload.comp_isVerified = false;
    }

    axios
      .post(process.env.REACT_APP_API + "users", payload, {
        headers: { "x-access-token": token },
      })
      .then((response) => {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data.rows,
          total: response.data.data.count,
        }));
        setPercentage(response?.data?.data?.percent);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchuserData();
  }, [pageState.page, pageState.pageSize, query, verfiecationStatus]);

  const fetchRoles = () => {
    const token = localStorage.getItem("accessToken");
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "admin/roles",
      headers: {
        "x-access-token": token,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);

        setRoles(response.data.data.rows);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleRoleChange = (event, userId) => {
    const selectedRole = event.target.value;
    updateUserRole(userId, selectedRole);
  };

  const updateUserRole = (userId, roleId) => {
    const token = localStorage.getItem("accessToken");

    const makeApiCall = () => {
      setLoading(true);
      axios
        .post(
          process.env.REACT_APP_API + `admin/users/${userId}/roles`,
          {
            roleId: roleId,
            updatedby: loginUserID,
          },
          {
            headers: {
              "x-access-token": token,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          if (response.status === 200) {
            Swal.fire({
              title: "User Role Updated Successfully",
              timer: 2500,
              timerProgressBar: true,
              icon: "success",
              confirmButtonText: "OK",
              showCloseButton: true,
            });
          }
          fetchuserData();
        })
        .catch((error) => {
          setLoading(false);
          Swal.fire({
            title: "Error",
            timer: 2500,
            timerProgressBar: true,
            text: error.response?.data?.message || "An error occurred",
            icon: "error",
            confirmButtonColor: "#f27474",
            confirmButtonText: "OK",
            dangerMode: true,
            showCloseButton: true,
          });
        });
    };

    if (roleId === 13) {
      Swal.fire({
        title: "Are you sure?",
        text: "Once assigned, this role cannot be changed. Are you sure you want to make this assignment?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, assign it!",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          makeApiCall();
        } else {
          setLoading(false);
        }
      });
    } else {
      makeApiCall();
    }
  };

  const roleColumn = {
    field: "role",
    headerName: "Role",
    width: 200,
    renderCell: (params) => (
      <Select
        value={params.row.roleId || ""}
        onChange={(event) => handleRoleChange(event, params.row.id)}
        displayEmpty
        fullWidth
        className="role-dropdown"
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #d0d0d0",
            borderRadius: "4px",
          },
          "& .MuiSelect-select": {
            fontSize: "14px",
            padding: "8px 12px",
            minHeight: "auto",
          },
          "& .MuiSelect-icon": {
            color: "#666",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#999",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#1976d2",
            borderWidth: "2px",
          },
        }}
      >
        {roles.map((role) => (
          <MenuItem key={role.id} value={role.id} sx={{ fontSize: "14px" }}>
            {role?.role}
          </MenuItem>
        ))}
      </Select>
    ),
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 180,
      renderCell: (params) => {
        const { corporateverificationStatus, comp_isVerified, id } =
          params?.row || {};
        const showEditIcon = corporateverificationStatus && !comp_isVerified;
        const hasEditPermission = validatePermission(
          "Users Management - Users:Edit",
          permissions,
          permissionsMapping
        );
        const hasDeletePermission = validatePermission(
          "Users Management - Users:Delete",
          permissions,
          permissionsMapping
        );

        return (
          <div className="cellAction">
            <Link to={`/users/${id}`} style={{ textDecoration: "none" }}>
              <div className="viewButton">
                {showEditIcon ? (
                  <EditOutlinedIcon className="custom-edit-icon" />
                ) : (
                  <RemoveRedEyeOutlinedIcon />
                )}
              </div>
            </Link>

            {hasEditPermission && (
              <div
                className="editButton"
                onClick={() => handleOpen(params.row)}
              >
                <EditOutlinedIcon />
              </div>
            )}

            {hasDeletePermission && (
              <div className="deleteButton" onClick={() => deleteFunction(id)}>
                <DeleteOutlineIcon />
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const statusColumn = [
    {
      field: "userStatus",
      headerName: "Status",
      width: 80,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <span
              className={`status ${
                params.row.userStatus == 1 ? "Approved" : "Pending "
              }`}
            >
              {params.row.userStatus == 1 ? "Active" : "Inactive"}
            </span>
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "profilePic",
      headerName: "Profile",
      width: 80,
      renderCell: (params) => {
        let progressCircularbar = percentage;
        return (
          <div className="cellWrapper ">
            <div className="profilePic">
              <img
                src={
                  params.row.profilePic == null
                    ? ProfilePic
                    : params?.row?.profilePic
                }
                className="userImage"
              />
              {progressCircularbar
                ?.filter((d) => d?.userid == params.row.id)
                ?.map((percentile) => (
                  <CircularProgressbar
                    key={percentile?.userid}
                    value={percentile?.percentage}
                    className="adminProfile-progress"
                  />
                ))}
            </div>
          </div>
        );
      },
    },
    {
      headerName: "Name",
      width: 150,
      renderCell: (params) => {
        return (
          params?.row?.firstname?.charAt(0)?.toUpperCase() +
          params?.row?.firstname?.slice(1) +
          " " +
          params?.row?.lastname?.charAt(0)?.toUpperCase() +
          params?.row?.lastname?.slice(1)
        );
      },
    },

    {
      field: "email",
      headerName: "Email",
      width: 200,
    },

    {
      field: "KYC_status",
      headerName: "Individual KYC Status",
      width: 200,
      renderCell: (params) => {
        const isVerified = params?.row?.isVerified;

        return <span>{isVerified == true ? "Verified" : "Not Verified"}</span>;
      },
    },
    {
      field: "Comp_KYC_status",
      headerName: "Corporate KYC Status",
      width: 170,
      renderCell: (params) => {
        const compIsVerified = params?.row?.comp_isVerified;

        return (
          <span>{compIsVerified == true ? "Verified" : "Not Verified"}</span>
        );
      },
    },
    {
      field: "userType",
      headerName: "Type Of User",
      width: 150,
      renderCell: (params) => {
        const userType = params?.row?.userType;
        return <span>{userType ? userType : "-"}</span>;
      },
    },
    // {
    //   field: "percent",
    //   headerName: "Progress",
    //   width: 250,
    //   renderCell: (params) => {
    //     let progressBar = percentage;
    //     return progressBar
    //       ?.filter((d) => d?.userid == params.row.id)
    //       ?.map((percentile) => (
    //         <LinearProgressWithLabel
    //           value={percentile?.percentage}
    //           key={percentile?.userid}
    //         />
    //       ));
    //   },
    // },
  ];
  const deleteFunction = (id) => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this user!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "patch",
          url: process.env.REACT_APP_API + "delete-user",
          headers: {
            "x-access-token": token,
          },
          data: {
            user_id: id,
            is_deleted: 1,
          },
        };

        axios(config)
          .then(function (response) {
            if (response.status == 200) {
              setLoading(false);
              // setOpen(false);
              Swal.fire({
                title: "User is deleted Successfully",
                timer: 2500,
                timerProgressBar: true,
                icon: "success",
                confirmButtonText: "OK",
                showCloseButton: true,
              });
            }
            fetchuserData();
          })

          .catch(function (error) {
            setLoading(false);
            if (error.response !== "" && error.response.data.message !== "") {
              Swal.fire({
                title: "Error",
                timer: 2500,
                timerProgressBar: true,
                text: error.response.data.message,
                icon: "error",
                confirmButtonColor: "#f27474",
                confirmButtonText: "OK",
                dangerMode: true,
                showCloseButton: true,
              });
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "User is not deleted", "error");
      }
    });
  };

  const updateUserInfo = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API + "admin/update-user-detail-byadmin",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: id,
        firstname: firstname,
        lastname: lastname,
      },
    };
    axios(config)
      .then(function (response) {
        if (response.data.status == 200) {
          setLoading(false);
          setOpen(false);
          Swal.fire({
            title: "User Information Updated Successfully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        setOpen(false);
        fetchuserData();

        // setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response !== "" && error.response.message !== "") {
          Swal.fire({
            title: "Error",
            timer: 2500,
            timerProgressBar: true,
            text: error.response.data.message,
            icon: "error",
            confirmButtonColor: "#f27474",
            confirmButtonText: "OK",
            dangerMode: true,
            showCloseButton: true,
          });
        }
      });
  };

  return (
    <div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          <input type="text" placeholder="Search..." onChange={handleQuery} />
          <SearchOutlinedIcon className="sarchicon" />
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Users</h5>
        <select
          value={verfiecationStatus}
          onChange={(e) => setVerificationStatus(e.target.value)}
          style={{ cursor: "pointer" }}
        >
          <option value="">All</option>
          <option value="individual_verified">Individual Verified</option>
          <option value="individual_non_verified">
            Individual Not Verified
          </option>
          <option value="corporate_verified">Corporate Verified</option>
          <option value="corporate_non_verified">Corporate Not Verified</option>
        </select>
      </div>
      <DataGrid
        className="datagrid"
        autoHeight
        rows={pageState.data}
        rowCount={pageState.total}
        rowsPerPageOptions={[10, 30, 50, 70, 100]}
        pagination
        page={pageState.page - 1}
        pageSize={pageState.pageSize}
        paginationMode="server"
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...old, page: newPage + 1 }));
        }}
        onPageSizeChange={(newPageSize) =>
          setPageState((old) => ({ ...old, pageSize: newPageSize }))
        }
        columns={userColumns.concat(statusColumn, roleColumn, actionColumn)}
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-popup">
          <div className="modal-top">
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Update User Information
            </Typography>
            <Button className="closeBtn" onClick={() => setOpen(false)}>
              <img src={Close} alt="close-icon" />
            </Button>
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 1 }}>
            <div className="new">
              <div className="newContainer">
                <div
                  className="bottom"
                  style={{ boxShadow: "none", padding: "0" }}
                >
                  <div className="right">
                    <form className="accredited-investorForm">
                      <div className="formInput" id="commissionInput">
                        <label>Firstname</label>
                        <input
                          type="text"
                          name="firstname"
                          placeholder="Enter FirstName"
                          value={firstname}
                          onChange={updateFirstName}
                        />
                      </div>
                      <div className="formInput" id="commissionInput">
                        <label>Lastname</label>
                        <input
                          type="text"
                          name="lastname"
                          placeholder="Enter LastName"
                          value={lastname}
                          onChange={updateLastName}
                        />
                      </div>

                      <div className="formInput" id="commissionInput">
                        <label>Email</label>
                        <input
                          type="text"
                          name="lastname"
                          placeholder="Enter LastName"
                          value={getEmail}
                          readOnly
                        />
                      </div>

                      <div className="item accreditedItem">
                        <div className="details profile-info">
                          <div className="submitButton">
                            <button
                              className="approveButton"
                              type="button"
                              disabled={!firstname || !lastname}
                              onClick={updateUserInfo}
                            >
                              Update
                            </button>

                            <button
                              className="cancelButton"
                              type="button"
                              onClick={() => setOpen(false)}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default Userlist;
